import config from '@/app/config';

export const createLocalStorage = function(config) {
  function set(variavel, valor) {
    const tipo = typeof valor;
    const isString = tipo === 'string';

    if (config.STORAGE_ENCRYPT) {
      valor = btoa(JSON.stringify(valor));
    } else {
      valor = isString ? valor : JSON.stringify(valor);
    }

    localStorage.setItem(config.APP_PREFIX + variavel, valor);
  }

  function get(variavel) {
    let valor = localStorage.getItem(config.APP_PREFIX + variavel);

    if (valor) {
      if (config.STORAGE_ENCRYPT) {
        valor = atob(valor);
      }

      return parseJSONSafe(valor);
    }

    return null;
  }

  function remove(variavel) {
    localStorage.removeItem(config.APP_PREFIX + variavel);
  }

  function has(variavel) {
    return !!localStorage.getItem(config.APP_PREFIX + variavel);
  }

  function parseJSONSafe(string) {
    try {
      return JSON.parse(string);
    } catch (error) {
      return string;
    }
  }

  return { set, get, remove, has };
};
  
export default function() {
  return createLocalStorage(config);
}